import { CustomerAccount, UserAccessStatus } from '@amzn/awscat-portfolio-assessment-types';
import { BadgeProps, RadioGroupProps, SelectProps, TilesProps } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';
import { AccountOptions, OrgTypes, PrepopulateTypes } from './interface';

export const emptyAccount: CustomerAccount = {accountId: '', accountName: '', ownerId: '', refId: '', territory: ''};

export const prepopulateItems: TilesProps.TilesDefinition[] = [
    {
        label: constants.PREPOP_EMPTY_LABEL,
        description: constants.PREPOP_EMPTY_DESP,
        value: PrepopulateTypes.EMPTY,
    },
    {
        label: constants.PREPOP_SAMPLE_LABEL,
        description: constants.PREPOP_SAMPLE_DESP,
        value: PrepopulateTypes.SAMPLE,
    },
];

export enum ClassificationTypes {
    CUSTOMER = 'customer',
    TEST = 'test',
};

export const classificationItems: TilesProps.TilesDefinition[] = [
    {
        label: constants.CLASSIFY_CUSTOMER_DATA_LABEL,
        description: constants.CLASSIFY_CUSTOMER_DATA_DESP,
        value: ClassificationTypes.CUSTOMER,
        disabled: false,
    }, {
        controlId: 'classificationTest',
        label: constants.CLASSIFY_TEST_DATA_LABEL,
        description: constants.CLASSIFY_TEST_DATA_DESP,
        value: ClassificationTypes.TEST,
        disabled: false,
    }
];

export const testAccountIDs = {
    [OrgTypes.AWS]: {
        [PrepopulateTypes.SAMPLE]: 'AWS:8bf35017-0cd6-42b5-a996-d2ce714fdedc',
        [PrepopulateTypes.EMPTY]: 'AWS:532700cb-c1e2-425d-afc9-b39e2a737a04'
    },
    [OrgTypes.other]: {
        [PrepopulateTypes.SAMPLE]: 'dd05a8b8-a6ef-4273-8e8e-2a29f07c67b0',
        [PrepopulateTypes.EMPTY]: '0fcc5ab8-ad2a-4681-8f4e-714a42e7c698'
    },
};

export const maxCustomerAccounts = 50;
export const salesforceCreateAccountUrl = 'https://c.na32.visual.force.com/apex/Create_Account?retURL=%2F001%2Fo&save_new=1&sfdc.override=1';

export const accountOptionsItems: RadioGroupProps.RadioButtonDefinition[] = [
    {
        label: constants.ACCOUNT_USE_EXISTING,
        value: AccountOptions.USE_EXISTING,
    },
    {
        label: constants.ACCOUNT_CREATE_NEW,
        value: AccountOptions.CREATE_NEW,
    },
];

type UserAccessStatusDisplay = {
    [key in UserAccessStatus]: {
        text: string;
        badgeColor: BadgeProps['color'];
    };
};

export const userAccessStatusDisplay: UserAccessStatusDisplay = {
    [UserAccessStatus.EXISTING]: {
        text: constants.SAVED,
        badgeColor: 'green',
    },
    [UserAccessStatus.INVITED]: {
        text: constants.INVITED,
        badgeColor: 'blue',
    },
    [UserAccessStatus.DELETE]: {
        text: constants.PENDING_DELETE,
        badgeColor: 'red',
    },
    [UserAccessStatus.INVITE]: {
        text: constants.PENDING_INVITE,
        badgeColor: 'blue',
    },
    [UserAccessStatus.ADD]: {
        text: constants.PENDING_ADD,
        badgeColor: 'blue',
    },
};

export const userActionOptions: SelectProps.Option[] = [
    //TODO: uncomment when porfolio implements view only capabilities
    // { value: 'View', label: constants.VIEW },
    { value: 'Update', label: constants.UPDATE_BUTTON_TEXT },
    { value: '*', label: constants.FULL }
];

export enum UserPermissionAccess {
    FULL = '*',
    UPDATE = 'Update',
}

export const awsUserChunkSize = 30;
export const nonAWSUserChunkSize = 5;
export const emailMaxLength = 254;
